import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, onLogout, onFeedbackClick }) {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-brand" onClick={() => navigate('/')}>
          <img src="/logo.png" alt="LaTeXLaB" className="nav-logo" />
        </div>

        <div className="nav-links">
          <a href="/#features" className="nav-link">Features</a>
          <a href="/#templates" className="nav-link">Templates</a>
          
          <button 
            className="btn btn-feedback"
            onClick={onFeedbackClick}
            style={{
              background: '#f59e0b',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            💬 Feedback
          </button>
          
          {user ? (
            <>
              <button 
                className="nav-link-btn"
                onClick={() => navigate('/editor')}
              >
                My Editor
              </button>
              <div className="nav-user">
                <span className="user-name">{user.name}</span>
                <button 
                  className="btn btn-logout"
                  onClick={onLogout}
                >
                  Logout
                </button>
              </div>
            </>
          ) : (
            <>
              <button 
                className="btn btn-outline"
                onClick={() => navigate('/login')}
              >
                Login
              </button>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/register')}
              >
                Sign Up Free
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
